<div class="selector-container">
  <span class="table-desc">{{ label }}</span>

  <table
    cdkDropList
    #selectorTable
    mat-table
    [dataSource]="inputData.controls"
    multiTemplateDataRows
    class="mat-elevation-z8"
    (cdkDropListDropped)="drop($event)"
  >
    <ng-container matColumnDef="drag">
      <th mat-header-cell *matHeaderCellDef></th>
      <td class="drag" mat-cell *matCellDef="let row">
        <mat-icon cdkDragHandle>drag_handle</mat-icon>
      </td>
    </ng-container>
    <ng-container matColumnDef="_class">
      <th mat-header-cell *matHeaderCellDef>type</th>
      <td mat-cell *matCellDef="let row">
        <div class="cell-content">{{ classToHumanName[row?.value?._class] }}</div>
      </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>name</th>
      <td mat-cell *matCellDef="let row">
        <div class="cell-content">
          {{ row._name?.value }}
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="size">
      <th mat-header-cell *matHeaderCellDef>size</th>
      <td mat-cell *matCellDef="let row">
        <div class="cell-content">
          {{ row._size?.value }}
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef class="actions">Actions</th>
      <td mat-cell *matCellDef="let element" class="actions">
        <button class="table-button" mat-button color="accent" (click)="deleteTemplate($event, element)">
          <mat-icon aria-label="icon button trash">delete</mat-icon>
        </button>
      </td>
    </ng-container>
    <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
    <ng-container matColumnDef="expandedDetail">
      <td mat-cell *matCellDef="let element" [attr.colspan]="columnsToDisplay.length">
        <div class="content-form" [@detailExpand]="element === expandedElement ? 'expanded' : 'collapsed'">
          <mat-card>
            <mat-card-content>
              <!--ajout d'un id-->

              <app-ui-form-parametredate
                id="parametredate_id"
                [formGroup]="$any(element)"
                *ngIf="element.value._class === 'ParametreDate'"
                [unVisibleComp]="unVisibleValue"
              >
              </app-ui-form-parametredate>

              <app-ui-form-parametrenumber
                id="parametrenumber_id"
                [formGroup]="$any(element)"
                *ngIf="element.value._class === 'ParametreNumber'"
                [unVisibleComp]="unVisibleValue"
              >
              </app-ui-form-parametrenumber>

              <app-ui-form-parametreboolean
                id="parametreboolean_id"
                [formGroup]="$any(element)"
                *ngIf="element.value._class === 'ParametreBoolean'"
                [unVisibleComp]="unVisibleValue"
              >
              </app-ui-form-parametreboolean>

              <app-ui-form-parametrelist
                id="parametrelist_id"
                [formGroup]="$any(element)"
                *ngIf="element.value._class === 'ParametreList'"
                [unVisibleComp]="unVisibleValue"
              >
              </app-ui-form-parametrelist>

              <app-ui-form-parametreperson
                id="parametreperson_id"
                [formGroup]="$any(element)"
                *ngIf="element.value._class === 'ParametrePerson'"
                [unVisibleComp]="unVisibleValue"
              >
              </app-ui-form-parametreperson>

              <app-ui-form-parametrestring
                id="parametrestring_id"
                [formGroup]="$any(element)"
                *ngIf="element.value._class === 'ParametreString'"
                [unVisibleComp]="unVisibleValue"
              >
              </app-ui-form-parametrestring>

              <app-ui-form-parametreaddress
                id="parametreaddress_id"
                [formGroup]="$any(element)"
                *ngIf="element.value._class === 'ParametreAddress'"
                [unVisibleComp]="unVisibleValue"
              >
              </app-ui-form-parametreaddress>

              <app-ui-form-parametredossier
                id="parametredossier_id"
                [formGroup]="$any(element)"
                *ngIf="element.value._class === 'ParametreDossier'"
                [unVisibleComp]="unVisibleValue"
              >
              </app-ui-form-parametredossier>

              <app-ui-form-parametredocument
                id="parametredocument_id"
                [formGroup]="$any(element)"
                *ngIf="element.value._class === 'ParametreDocument'"
                [unVisibleComp]="unVisibleValue"
              >
              </app-ui-form-parametredocument>

              <app-ui-form-parametrerentreportlist
                id="parametrerentreportlist_id"
                [formGroup]="$any(element)"
                *ngIf="element.value._class === 'ParametreRentReportList'"
                [unVisibleComp]="unVisibleValue"
              >
              </app-ui-form-parametrerentreportlist>

              <app-ui-form-parametremonthlyrentreportlist
                id="parametremonthlyrentreportlist_id"
                [formGroup]="$any(element)"
                *ngIf="element.value._class === 'ParametreMonthlyRentReportList'"
                [unVisibleComp]="unVisibleValue"
              >
              </app-ui-form-parametremonthlyrentreportlist>

              <app-ui-form-parametertab id="parametertab_id" [formGroup]="$any(element)" *ngIf="element.value._class === 'ParameterTab'">
              </app-ui-form-parametertab>

              <app-ui-form-parametergroup id="parametergroup_id" [formGroup]="$any(element)" *ngIf="element.value._class === 'ParameterGroup'">
              </app-ui-form-parametergroup>

              <app-ui-form-parameterdivider id="parameterdivider_id" [formGroup]="$any(element)" *ngIf="element.value._class === 'ParameterDivider'">
              </app-ui-form-parameterdivider>

              <app-ui-form-parameterlistactservice
                id="parameterlistactservice_id"
                [formGroup]="$any(element)"
                *ngIf="element.value._class === 'ParameterListActService'"
                [unVisibleComp]="unVisibleValue"
              >
              </app-ui-form-parameterlistactservice>

              <app-ui-form-parametrecurrency
                id="parametrecurrency_id"
                [formGroup]="$any(element)"
                *ngIf="element.value._class === 'ParametreCurrency'"
                [unVisibleComp]="unVisibleValue"
              >
              </app-ui-form-parametrecurrency>

              <app-ui-form-parametercomponent
                id="parametercomponent_id"
                [formGroup]="$any(element)"
                *ngIf="element.value._class === 'ParameterComponent'"
                [unVisibleComp]="unVisibleValue"
              >
              </app-ui-form-parametercomponent>

              <app-ui-form-parametercomponentlist
                id="parametercomponentlist_id"
                [formGroup]="$any(element)"
                *ngIf="element.value._class === 'ParameterComponentList'"
                [unVisibleComp]="unVisibleValue"
              >
              </app-ui-form-parametercomponentlist>

              <app-ui-form-parametertextarea
                id="parametertextarea_id"
                [formGroup]="$any(element)"
                *ngIf="element.value._class === 'ParameterTextArea'"
                [unVisibleComp]="unVisibleValue"
              >
              </app-ui-form-parametertextarea>

              <app-ui-form-parameterdocumentlink
                id="parameterdocumentlink_id"
                [formGroup]="$any(element)"
                *ngIf="element.value._class === 'ParameterDocumentLink'"
                [unVisibleComp]="unVisibleValue"
              >
              </app-ui-form-parameterdocumentlink>
            </mat-card-content>
          </mat-card>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="addObject">
      <td mat-footer-cell *matFooterCellDef [attr.colspan]="columnsToDisplay.length">
        <button mat-button [matMenuTriggerFor]="addObj">Composant générique</button>

        <mat-menu #addObj="matMenu" yPosition="above">
          <!-- Paramter Ui -->

          <button mat-menu-item (click)="addItemByMenu('ParameterTab')">Onglet</button>
          <button mat-menu-item (click)="addItemByMenu('ParameterDivider')">Diviseur</button>

          <!-- Parameter Component -->
          <button mat-menu-item (click)="addItemByMenu('ParameterComponent')">Composant</button>
          <button mat-menu-item (click)="addItemByMenu('ParameterComponentList')">Liste de Composant</button>

          <!-- Paramter input -->

          <button mat-menu-item (click)="addItemByMenu('ParametreString')">Text</button>

          <button mat-menu-item (click)="addItemByMenu('ParametreDate')">Date</button>

          <button mat-menu-item (click)="addItemByMenu('ParametreNumber')">Nombre</button>

          <button mat-menu-item (click)="addItemByMenu('ParametreBoolean')">Booléen</button>

          <button mat-menu-item (click)="addItemByMenu('ParameterTextArea')">Paragraphe</button>

          <button mat-menu-item (click)="addItemByMenu('ParametreCurrency')">Devise</button>

          <button mat-menu-item (click)="addItemByMenu('ParametreList')">Liste à choix</button>

          <!-- Document -->

          <button mat-menu-item (click)="addItemByMenu('ParametreDocument')">Document</button>
          <button mat-menu-item (click)="addItemByMenu('ParameterDocumentLink')">Lien vers un document</button>

          <!-- Act -->

          <button mat-menu-item (click)="addItemByMenu('ParametreDossier')">Lien vers un Dossier</button>

          <!-- Affichage de tableau de dossier lier au dossier actuel filtre par service -->
          <button mat-menu-item (click)="addItemByMenu('ParameterListActService')">Tableau de Dossier par service</button>
        </mat-menu>

        <button mat-button [matMenuTriggerFor]="addCustomComponent">Composants Personnalisés</button>

        <mat-menu #addCustomComponent="matMenu" yPosition="above">
          <ng-container *ngFor="let modelComponent of modelComponents">
            <button mat-menu-item (click)="addCustomComponentByMenu(modelComponent)">{{ modelComponent.name }}</button>
          </ng-container>
        </mat-menu>

        <button mat-button [matMenuTriggerFor]="addCustomComponentList">Liste Composants Personnalisés</button>

        <mat-menu #addCustomComponentList="matMenu" yPosition="above">
          <ng-container *ngFor="let modelComponent of modelComponents">
            <button mat-menu-item (click)="addCustomComponentListByMenu(modelComponent)">{{ modelComponent.name }}</button>
          </ng-container>
        </mat-menu>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
    <tr
      cdkDrag
      mat-row
      *matRowDef="let element; columns: columnsToDisplay"
      class="element-row"
      [class.expanded-row]="expandedElement === element"
      (click)="expandedElement = expandedElement === element ? null : element"
    ></tr>
    <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>
    <tr mat-footer-row *matFooterRowDef="['addObject']"></tr>
  </table>
</div>
